import type { ComputedRef, Ref } from 'vue';
import { computed } from 'vue';

import { useFormatDate } from '@modules/core/composables/datetime';
import { useI18n } from '@modules/i18n/composables';

export interface IStatusDescriptionOptions {
  date: Maybe<string>;
  name: Maybe<string>;
  translationKey: symbol;
  shortCode: string;
  dateProp: string;
  nameProp: string;
}
export interface AffiliateStatusDescriptionComposable {
  description: ComputedRef<string>;
}

export default function useStatusDescription(
  options: Ref<IStatusDescriptionOptions>,
): AffiliateStatusDescriptionComposable {
  const { getTranslation } = useI18n();
  const { formatDate } = useFormatDate();

  const description = computed(() => {
    if (!options.value.date && !options.value.name)
      return '';

    const date = options.value.date ? formatDate(options.value.date, 'PPp') : '';

    return getTranslation(options.value.translationKey, options.value.shortCode, {
      [options.value.nameProp]: options.value.name,
      [options.value.dateProp]: date,
    }).value;
  });

  return {
    description,
  };
}
